import { PaginatedListResponse } from "@/domain/dto/BaseDataResponse";
import { ListProfessionalsQueryParamsDTO } from "@/domain/dto/ListProfessionalsQueryParamsDTO";
import { EligibleProfessional } from "@/domain/entities/EligibleProfessional";
import { IProfessionalRepository } from "@/domain/repositories/IProfessionalRepository";
import { IListProfessionalsUseCase } from "@/domain/usecases/IListProfessionalsUseCase";

export class ListProfessionalsUseCase implements IListProfessionalsUseCase {
    repository: IProfessionalRepository
    constructor(repository: IProfessionalRepository) {
        this.repository = repository
    }
    execute(params: ListProfessionalsQueryParamsDTO): Promise<PaginatedListResponse<EligibleProfessional>> {
        return this.repository.listProfessionals(params)
    }
}
